<!-- A rendeléshez kötött taskok és levelezések. Csak akkor látszik, ha van ilyen. -->
<div class="sup-card" *ngIf="loaded && total > 0">
  <div class="sup-card__head">
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><circle cx="12" cy="12" r="3.6"></circle><line x1="5.8" y1="5.8" x2="9.5" y2="9.5"></line><line x1="18.2" y1="5.8" x2="14.5" y2="9.5"></line><line x1="5.8" y1="18.2" x2="9.5" y2="14.5"></line><line x1="18.2" y1="18.2" x2="14.5" y2="14.5"></line></svg>
    <h3 class="sup-card__title">Support</h3>
    <span class="sup-card__pill" *ngIf="openTickets > 0">{{ openTickets }} nyitott task</span>
    <span class="sup-card__count">{{ total }} kapcsolat</span>
  </div>

  <!-- Taskok -->
  <div class="sup-group" *ngIf="tickets.length">
    <div class="sup-group__label">Task{{ tickets.length > 1 ? 'ok' : '' }}</div>
    <a class="sup-item" *ngFor="let t of tickets" [routerLink]="['/support']" [queryParams]="{ ticket: t.id }"
       [class.sup-item--done]="t.done" [title]="'Megnyitás: ' + t.displayId + ' · ' + t.title">
      <span class="sup-item__icon sup-item__icon--ticket">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="3"></rect><polyline points="8.5,12 11,14.5 15.5,9.5"></polyline></svg>
      </span>
      <span class="sup-item__body">
        <span class="sup-item__top">
          <span class="sup-item__id">{{ t.displayId }}</span>
          <span class="sup-item__title">{{ t.title }}</span>
        </span>
        <span class="sup-item__meta">
          <span class="sup-status" [style.background]="t.statusColor ? t.statusColor + '22' : null" [style.color]="t.statusColor">{{ t.status }}</span>
          <span class="sup-prio" [ngClass]="prioClass(t.priority)">{{ t.priority }}</span>
          <span class="sup-item__sub">{{ assigneeLabel(t) }}</span>
        </span>
        <span class="sup-item__via" *ngIf="t.via">az {{ t.via }} levelezésen keresztül</span>
      </span>
      <svg class="sup-item__go" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9,5 16,12 9,19"></polyline></svg>
    </a>
  </div>

  <!-- Levelezések -->
  <div class="sup-group" *ngIf="threads.length">
    <div class="sup-group__label">Levelezés{{ threads.length > 1 ? 'ek' : '' }}</div>
    <a class="sup-item" *ngFor="let m of threads" [routerLink]="['/support/levelezes']" [queryParams]="{ thread: m.id }"
       [class.sup-item--unread]="m.unread" [title]="'Megnyitás: ' + m.displayId + ' · ' + m.subject">
      <span class="sup-item__icon sup-item__icon--mail">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="5" width="18" height="14" rx="2.5"></rect><polyline points="3.5,7 12,13 20.5,7"></polyline></svg>
        <i class="sup-item__dot" *ngIf="m.unread"></i>
      </span>
      <span class="sup-item__body">
        <span class="sup-item__top">
          <span class="sup-item__id">{{ m.displayId }}</span>
          <span class="sup-item__title">{{ m.subject }}</span>
        </span>
        <span class="sup-item__meta">
          <span class="sup-status" [class.sup-status--closed]="m.status === 'closed'">{{ mailStatus(m) }}</span>
          <span class="sup-item__sub">{{ m.customer }} · {{ m.messageCount }} levél · {{ m.lastDirection === 'in' ? 'utolsó: tőle' : 'utolsó: mi' }} {{ when(m.lastMessageAt) }}</span>
        </span>
        <span class="sup-item__via" *ngIf="m.via">a {{ m.via }} taskon keresztül</span>
      </span>
      <svg class="sup-item__go" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9,5 16,12 9,19"></polyline></svg>
    </a>
  </div>
</div>
